// Awaab's Law and Damp Detection Data

export const awaabsLawInfo = {
  title: "Awaab's Law Compliance",
  subtitle: "Protect tenants. Meet UK regulations. Prevent damp & mould hazards.",
  description: "Named after two-year-old Awaab Ishak who tragically died from mould exposure, Awaab's Law sets strict requirements for social housing landlords in England to investigate and remediate damp and mould hazards.",
  effectiveDate: "October 2025"
};

export const legalRequirements = [
  {
    title: "Emergency Hazards",
    timeframe: "24 hours",
    description: "If a hazard poses an immediate threat to life, landlords must investigate and begin remediation within 24 hours of notification."
  },
  {
    title: "Damp & Mould Reports",
    timeframe: "14 days",
    description: "Landlords must investigate reports of damp or mould within 14 days of becoming aware of the issue."
  },
  {
    title: "Written Report to Tenant",
    timeframe: "48 hours - 14 days",
    description: "After investigation, provide a written report to the tenant summarising findings, causes, and next steps."
  },
  {
    title: "Repairs for Significant Hazards",
    timeframe: "7 days",
    description: "If the investigation identifies a significant health and safety risk, repairs must be completed within 7 days."
  }
];

export const dampDefenderKits = [
  {
    name: "Starter Kit",
    ideal: "Small homes or flats (1-2 rooms)",
    price: "£379",
    weeklyPrice: "£7.29",
    stripePaymentLink: "https://buy.stripe.com/bJe3co52M1dEglCbZN6c00e",
    includes: [
      "2× Sensative Comfort Sensors (Humidity & Temperature)",
      "1× Sensative Drip Sensor (Leak detection)",
      "1× LoRaWAN Gateway (Wi-Fi)",
      "10-year battery life",
      "Yggio platform access"
    ]
  },
  {
    name: "House Kit",
    ideal: "Full-home coverage (2-3 floors)",
    price: "£429",
    weeklyPrice: "£8.25",
    stripePaymentLink: "https://buy.stripe.com/4gM5kweDmg8yglCbZN6c00d",
    includes: [
      "4× Sensative Comfort Sensors",
      "2× Sensative Drip Sensors",
      "1× LoRaWAN Gateway",
      "10-year battery life",
      "Yggio platform access"
    ],
    popular: true
  },
  {
    name: "Estate Kit",
    ideal: "Large houses / multi-unit properties",
    price: "£629",
    weeklyPrice: "£12.10",
    stripePaymentLink: "https://buy.stripe.com/cNiaEQbra4pQd9qaVJ6c00c",
    includes: [
      "8× Sensative Comfort Sensors",
      "4× Sensative Drip Sensors",
      "2× LoRaWAN Gateways (dual coverage)",
      "10-year battery life",
      "Yggio platform access"
    ]
  }
];

export const dampDetectionFeatures = [
  {
    icon: "Clock",
    title: "Quick Installation",
    description: "Stick sensors in minutes—no wiring, no complexity. Self-adhesive mounting with instant activation."
  },
  {
    icon: "Bell",
    title: "24/7 Monitoring",
    description: "Continuous tracking of humidity, temperature, and water leaks. Real-time data via Yggio platform."
  },
  {
    icon: "Smartphone",
    title: "Instant Alerts",
    description: "Immediate notifications to phone or email when humidity exceeds safe levels or leaks are detected."
  },
  {
    icon: "Battery",
    title: "10-Year Battery",
    description: "Sensative sensors with exceptional longevity. Minimal maintenance, maximum reliability."
  },
  {
    icon: "Shield",
    title: "UK Compliance",
    description: "Built to support Awaab's Law requirements. Document conditions, respond quickly, protect tenants."
  },
  {
    icon: "FileText",
    title: "Automated Reporting",
    description: "Historical data and reports for compliance documentation. Evidence-based tenant communication."
  }
];

export const complianceBenefits = [
  "Detect damp and mould before it becomes visible",
  "Meet 14-day investigation requirements",
  "Document environmental conditions for tenant reports",
  "Prevent costly emergency repairs (£2,000-£3,000 average)",
  "Protect tenant health and reduce liability",
  "Avoid regulatory fines from Housing Regulator",
  "Maintain property value and tenant satisfaction"
];

export const testimonial = {
  quote: "The sensors caught a leak before tenants noticed. Prevented major mould damage and saved us over £1,200 in repairs. Essential for Awaab's Law compliance.",
  author: "James M.",
  role: "Social Housing Landlord, Manchester",
  properties: "Managing 12 properties"
};
